import { observer } from 'mobx-react-lite'

import { CollaborationDialogCloseButton } from './CollaborationDialogCloseButton'
import { CollaborationDialogHead } from './CollaborationDialogHead'
import { useCollaborationDialog } from './CollaborationDialogStore'

import Styles from './CollaborationDialogNewCommentHead.module.scss'

export const CollaborationDialogNewCommentHead = observer(function CollaborationDialogNewCommentHead() {
  const store = useCollaborationDialog()
  return (
    <CollaborationDialogHead>
      <div className={Styles.title}>Insert new comment</div>
      <div className={Styles.right}>
        <CollaborationDialogCloseButton onClose={store.closeNewComment} />
      </div>
    </CollaborationDialogHead>
  )
})
